import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
// import selectSoundSource from '@/widgets/selectSoundSource'
// import selectProfile from '@/widgets/selectProfile'
// import btnSupport from '@/widgets/btnSupport'
// import profiles from '@/widgets/profiles'
// import chartDoseLevelDuration from '@/widgets/chartDoseLevelDuration'
// import chartLevelTimeOfDay from '@/widgets/chartLevelTimeOfDay'
// import chartMap from '@/widgets/chartMap'
// import chartDBDoughnut from '@/widgets/chartDBDoughnut'
// import chartAgeAreaCompare from '@/widgets/chartAgeAreaCompare'
let Dashboard = class Dashboard extends Vue {
    // import selectSoundSource from '@/widgets/selectSoundSource'
    // import selectProfile from '@/widgets/selectProfile'
    // import btnSupport from '@/widgets/btnSupport'
    // import profiles from '@/widgets/profiles'
    // import chartDoseLevelDuration from '@/widgets/chartDoseLevelDuration'
    // import chartLevelTimeOfDay from '@/widgets/chartLevelTimeOfDay'
    // import chartMap from '@/widgets/chartMap'
    // import chartDBDoughnut from '@/widgets/chartDBDoughnut'
    // import chartAgeAreaCompare from '@/widgets/chartAgeAreaCompare'
    constructor() {
        super(...arguments);
        this.full = {
            doseChart: false,
            map: false
        };
    }
    get showAll() {
        for (var key in this.full) {
            if (this.full[key])
                return false;
        }
        return true;
    }
    toggleFull(name) {
        this.full[name] = !this.full[name];
    }
};
Dashboard = tslib_1.__decorate([
    Component({
        components: {
            "select-sound-source": () => import(/* webpackChunkName: "select-sound-source" */ "@/widgets/selectSoundSource.vue"),
            "select-profile": () => import(/* webpackChunkName: "select-profile" */ "@/widgets/selectProfile/index.vue"),
            "btn-support": () => import(/* webpackChunkName: "btn-support" */ "@/widgets/btnSupport.vue"),
            // widget imports async
            "chart-dose-level-duration": () => import(/* webpackChunkName: "widget-chartDoseLevelDuration" */ "@/widgets/chartDoseLevelDuration"),
            "chart-level-time-of-day": () => import(/* webpackChunkName: "widget-chartLevelTimeOfDay" */ "@/widgets/chartLevelTimeOfDay.vue"),
            "chart-map": () => import(/* webpackChunkName: "widget-chartMap" */ "@/widgets/chartMap"),
            "chart-age-area-compare": () => import(/* webpackChunkName: "widget-chartAgeAreaCompare" */ "@/widgets/chartAgeAreaCompare"),
            "chart-db-doughnut": () => import(/* webpackChunkName: "widget-chartDBDoughnut" */ "@/widgets/chartDBDoughnut")
            // static widget imports
            // 'chart-dose-level-duration': chartDoseLevelDuration,
            // 'chart-level-time-of-day': chartLevelTimeOfDay,
            // 'chart-map': chartMap,
            // 'chart-age-area-compare': chartAgeAreaCompare,
            // 'chart-db-doughnut': chartDBDoughnut
        }
    })
], Dashboard);
export default Dashboard;
